<template>
  <div>
    <div class="mobile-home">
      <!-- 顶部介绍区域 -->
      <div class="introduce">
        <h2>{{ $t('Home.Mobile.GetRidOfSupplier') }}</h2>
        <h2>{{ $t('Home.Mobile.IssuesWith') }} <span style="color: #9AC331;">KakaClo</span></h2>
        <h2 style="color: #9AC331;">{{ $t('Home.Mobile.DROPSHIPPING') }}</h2>
        <ul>
          <li>{{ $t('Home.Home.VerifiedSuppliers') }}</li><br>
          <li>{{ $t('Home.Home.SpecializingIn') }}</li><br>
          <li>{{ $t('Home.Home.NoFulfillment') }}</li><br>
          <li>{{ $t('Home.Home.DailyUpdate') }}</li>
        </ul>
        <p class="tip">{{ $t('Home.Home.StablyCooperated') }} </p>
        <el-button v-if="userId" @click="jump('/mall')">{{ $t('Dropshipping.Module1.StartSelling') }}</el-button>
        <el-button v-else @click="jump('/register')">{{ $t('Dropshipping.Module1.SignUpForFree') }}</el-button>
        <div class="sample-display f-c-c">
          <!-- <iframe width="100%" height="100%" style="border: 2px solid #9AC331;border-radius: 12px;" src="https://www.youtube.com/embed/oK3gWeyJm80?si=SVm2cgSaf2MfMZbH" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe> -->
          <div class="play-img pointer" @click="()=>$emit('playVideo','https://img.kakaclo.com/web-img/home/video/video/introduce.mp4')">
            <oss-img :width="40" :height="40" src="https://img.kakaclo.com/web-img/home/home2.0/Slice%202546%202x.png" alt="img" />
          </div>
        </div>
      </div>
      <div class="introduce-advantage-list">
        <div class="introduce-advantage fd-c f-c-c">
          <div class="semi"><oss-img :width="48" :height="48" src="https://img.kakaclo.com/web-img/home/Slice%202583%402x.png" alt="img" /></div>
          <h3>{{ $t('Home.Home.Quality') }}</h3>
          <h6>{{ $t('Home.Home.StrictQC') }}</h6>
          <p>{{ $t('Home.Home.EverySingle') }}</p>
        </div>
        <div class="introduce-advantage fd-c f-c-c">
          <div class="semi"><oss-img :width="48" :height="48" src="https://img.kakaclo.com/web-img/home/Slice%202584%402x.png" alt="img" /></div>
          <h3>{{ $t('Home.Home.Prices') }}</h3>
          <h6>{{ $t('Home.Home.StartFrom') }}</h6>
          <p>{{ $t('Home.Home.StablyCooperatedWith') }}</p>
        </div>
        <div class="introduce-advantage fd-c f-c-c">
          <div class="semi"><oss-img :width="48" :height="48" src="https://img.kakaclo.com/web-img/home/Slice%202586%402x.png" alt="img" /></div>
          <h3>{{ $t('Home.Home.Styles') }}</h3>
          <h6>SKU 1,000,000+ </h6>
          <p>{{ $t('Home.Home.AllCategories') }}</p>
        </div>
        <div class="introduce-advantage fd-c f-c-c">
          <div class="semi"><oss-img :width="48" :height="48" src="https://img.kakaclo.com/web-img/home/Slice%202585%402x.png" alt="img" /></div>
          <h3>{{ $t('Home.Home.OnTrend') }}</h3>
          <h6>{{ $t('Home.Home.DailyUpdate1000') }}</h6>
          <p>{{ $t('Home.Home.MoreThan1000') }}</p>
        </div>
      </div>

      <!-- 产品轮播图区域 -->
      <div class="banner-box">
        <div class="banner">
          <Banner />
          <div class="pointer" @click="jump('/mall')">{{ $t('Home.Home.ViewAll') }} <i class="iconfont icon-arrow-right-line"></i></div>
        </div>
      </div>
      <!-- 产品展示区 -->
      <div class="goods-exhibition">
        <h2>{{ $t('Home.Home.ClothingWholesale') }}</h2>
        <div class="content f fw-w f-b-c">
          <div class="img-box">
            <div class="img-description">
              <div>
                <h2>{{ $t('Home.Home.Tops') }}</h2>
                <a href="/product-list/women/tops" target="_blank"> <el-button type="primary"> {{$t('Home.Home.ShopNow')}}</el-button></a>
              </div>
            </div>
            <div class="product-img"><oss-img :width="164" :height="312" src="https://img.kakaclo.com/web-img/home/mobilehome2.0/mobile2412%402x%20(42).png" alt="img" /></div>
          </div>
          <div class="img-box">
            <div class="img-description">
              <div>
                <h2>{{ $t('Home.Home.Blouses') }}</h2>
                <a href="/product-list/women/tops-shirts-blouses'" target="_blank"><el-button type="primary"> {{$t('Home.Home.ShopNow')}}</el-button></a>
              </div>
            </div>
            <div class="product-img"><oss-img :width="164" :height="312" src="https://img.kakaclo.com/web-img/home/mobilehome2.0/mobile2412%402x%20(41).png" alt="img" /></div>
          </div>
          <div class="img-box">
            <div class="img-description">
              <div>
                <h2>{{ $t('Home.Home.Dress') }}</h2>
                <a href="/product-list/women/dresses" target="_blank"><el-button type="primary">{{$t('Home.Home.ShopNow')}}</el-button></a>
              </div>
            </div>
            <div class="product-img"><oss-img :width="164" :height="312" src="https://img.kakaclo.com/web-img/home/mobilehome2.0/mobile2412%402x%20(35).png" alt="img" /></div>
          </div>
          <div class="img-box">
            <div class="img-description">
              <div>
                <h2>{{ $t('Home.Home.Jumpsuit') }}</h2>
                <a href="/product-list/Women/Jumpsuits-Rompers-Jumpsuits" target="_blank"> <el-button type="primary"> {{$t('Home.Home.ShopNow')}} </el-button></a>
              </div>
            </div>
            <div class="product-img"><oss-img :width="164" :height="312" src="https://img.kakaclo.com/web-img/home/mobilehome2.0/mobile2412%402x%20(40).png" alt="img" /></div>
          </div>
          <div class="img-box">
            <div class="img-description">
              <div>
                <h2>{{ $t('Home.Home.Lingerie') }}</h2>
                <a href="/product-list/women/lingerie" target="_blank"><el-button type="primary">{{$t('Home.Home.ShopNow')}}</el-button></a>
              </div>
            </div>
            <div class="product-img"><oss-img :width="164" :height="312" src="https://img.kakaclo.com/web-img/home/mobilehome2.0/mobile2412%402x%20(36).png" alt="img" /></div>
          </div>
          <div class="img-box">
            <div class="img-description">
              <div>
                <h2>{{ $t('Home.Home.Denim') }}</h2>
                <a href="/product-list/Women/Jeans-Denim" target="_blank"><el-button type="primary">{{$t('Home.Home.ShopNow')}}</el-button></a>
              </div>
            </div>
            <div class="product-img"><oss-img :width="164" :height="312" src="https://img.kakaclo.com/web-img/home/mobilehome2.0/mobile2412%402x%20(38).png" alt="img" /></div>
          </div>
          <div class="img-box">
            <div class="img-description">
              <div>
                <h2>{{ $t('Home.Home.Sport') }}</h2>
                <a href="/product-list/Women/Activewear" target="_blank"> <el-button type="primary"> {{$t('Home.Home.ShopNow')}}</el-button></a>
              </div>
            </div>
            <div class="product-img"><oss-img :width="164" :height="312" src="https://img.kakaclo.com/web-img/home/mobilehome2.0/mobile2412%402x%20(37).png" alt="img" /></div>
          </div>
          <div class="img-box">
            <div class="img-description">
              <div>
                <h2>{{ $t('Home.Home.Pajamas') }}</h2>
                <a href="/product-list/Women/Pajamas-Loungewear" target="_blank"><el-button type="primary"> {{$t('Home.Home.ShopNow')}}</el-button></a>
              </div>
            </div>
            <div class="product-img"><oss-img :width="164" :height="312" src="https://img.kakaclo.com/web-img/home/mobilehome2.0/mobile2412%402x%20(39).png" alt="img" /></div>
          </div>
        </div>
        <div class="pointer" @click="jump('/product-list', 542)">{{ $t('Home.Mobile.ViewAll') }} <i class="iconfont icon-arrow-right-line"></i></div>
      </div>

      <!-- 销量展示区域 -->
      <div class="sales-volume">
        <div class="sales-box">
          <div class="text">
            <h2>{{ $t('Home.Mobile.YourNewSecretWeaponIn') }} <br />{{ $t('Home.Mobile.TheFashionBusiness') }}</h2>
            <p>{{ $t('Home.Mobile.Tips1') }} <br> {{ $t('Home.Mobile.Tips2') }}<br> {{ $t('Home.Mobile.Tips3') }} </p>
          </div>
          <div class="sales">
            <div class="sales-item">
              <div class="number">8,600+</div>
              <div class="describe">{{ $t('Home.Home.ClothingWithCooperated') }}</div>
            </div>
            <div class="sales-item">
              <div class="number">11,000+</div>
              <div class="describe">{{ $t('Home.Home.TrustedByFashion') }}</div>
            </div>
            <div class="sales-item">
              <div class="number">Low MOQ</div>
              <div class="describe">{{ $t('Home.Home.RequireFor') }}</div>
            </div>
            <div class="sales-item">
              <div class="number">24/7</div>
              <div class="describe">{{ $t('Home.Home.OfferInClass') }}</div>
            </div>
          </div>
        </div>
      </div>

      <!-- 支持的站点 -->
      <div class="supported-site f-c-c">
        <a href="https://www.presseportal.ch/de/pm/100089245/100885125" target="_blank">
          <oss-img :width="82" :height="25" src="https://img.kakaclo.com/web-img/home/home2.0/Slice%202421%402x.png" alt="img" />
        </a>
        <a href="https://finance.yahoo.com/news/kakaclo-rolls-ai-feature-help-153000538.html" target="_blank">
          <oss-img :width="82" :height="25" src="https://img.kakaclo.com/web-img/home/link_icon2.png" alt="img" />
        </a>
        <a href="https://www.prnewswire.com/news-releases/kakaclo-rolls-out-ai-feature-to-help-their-user-grasp-the-central-fashion-trends-on-instagram-301602609.html" target="_blank">
          <oss-img :width="82" :height="25" src="https://img.kakaclo.com/web-img/home/link_icon3.png" alt="img" />
        </a>
        <a href="https://www.fibre2fashion.com/news/textile-news/hong-kong-s-kakaclo-s-supply-chain-platform-now-online--279067-newsdetails.htm" target="_blank">
          <oss-img :width="82" :height="25" src="https://img.kakaclo.com/web-img/home/home2.0/Slice%202424%402x.png" alt="img" />
        </a>
      </div>
      <!-- 产品品类列表 -->
      <CategroyProductList />
      <!-- 顾客故事 -->
      <div class="customer-story">
        <h2>Customer Stories</h2>
        <div ref="parent" class="container">
          <div ref="child" class="store-list f">
            <div class="store-box">
              <div class="store-header f">
                <div class="avator"><oss-img :width="48" :height="48" src="https://img.kakaclo.com/web-img/home/avator%20(5).png" alt="img" /></div>
                <div>
                  <h6>TeArra</h6>
                  <p>iClosam, Founder</p>
                </div>
              </div>
              <div class="semi"><oss-img :width="35" :height="24" src="https://img.kakaclo.com/web-img/home/home2.0/semi.png" alt="img" /></div>
              <p>Setting up my Shopify account was the first step; finding the right dropshipping partner was the next. That's when I discovered KakaClo. Unlike other platforms, KakaClo stands out with its clothing specialization, offering an extensive range of styles and timely updates. Their fast logistics from China to the US have been a game-changer, ensuring my customers receive their orders swiftly.</p>
              <el-button @click="()=>$emit('playVideo','https://img.kakaclo.com/web-img/home/video/video/6.mp4')">{{ $t('Home.Home.PlayVideo') }}</el-button>
            </div>
            <div class="store-box">
              <div class="store-header f">
                <div class="avator"><oss-img :width="48" :height="48" src="https://img.kakaclo.com/web-img/home/avator%20(2).png" alt="img" /></div>
                <div>
                  <h6>Mike</h6>
                  <p>Halton, Owner</p>
                </div>
              </div>
              <div class="semi"><oss-img :width="35" :height="24" src="https://img.kakaclo.com/web-img/home/home2.0/semi.png" alt="img" /></div>
              <p>Recognizing my inability to manage storage and shipping, I found a solution in KakaClo. This platform has revolutionized my inventory management, providing depth without the responsibility for unsold stock. Their 24/7 live customer support has been an invaluable resource, ensuring smooth operations and immediate assistance whenever needed.</p>
              <el-button @click="()=>$emit('playVideo','https://img.kakaclo.com/web-img/home/video/video/3.mp4')">{{ $t('Home.Home.PlayVideo') }}</el-button>
            </div>
            <div class="store-box">
              <div class="store-header f">
                <div class="avator"><oss-img :width="48" :height="48" src="https://img.kakaclo.com/web-img/home/avator%20(3).png" alt="img" /></div>
                <div>
                  <h6>Diana</h6>
                  <p>PRESSFIY, Owner</p>
                </div>
              </div>
              <div class="semi"><oss-img :width="35" :height="24" src="https://img.kakaclo.com/web-img/home/home2.0/semi.png" alt="img" /></div>
              <p>Our collaboration with KakaClo Dropshipping has been transformative for our brand. The platform's diverse selection, featuring both new and established designers worldwide, has significantly boosted our sales. Their excellent customer service and efficient problem-solving have elevated my boutique, enabling us to reach new heights and better serve our customers.</p>
              <el-button @click="()=>$emit('playVideo','https://img.kakaclo.com/web-img/home/video/video/5.mp4')">{{ $t('Home.Home.PlayVideo') }}</el-button>
            </div>
            <div class="store-box">
              <div class="store-header f">
                <div class="avator"><oss-img :width="48" :height="48" src="https://img.kakaclo.com/web-img/home/avator%20(4).png" alt="img" /></div>
                <div>
                  <h6>Tamara</h6>
                  <p>Brand Owner</p>
                </div>
              </div>
              <div class="semi"><oss-img :width="35" :height="24" src="https://img.kakaclo.com/web-img/home/home2.0/semi.png" alt="img" /></div>
              <p>I stumbled upon KakaClo while searching for a reliable dropshipping service for my Shopify store. What drew me to KakaClo was its specialization in fashion. Since partnering, I've seen a notable increase in my inventory's variety and a reduction in delivery times, thanks to their efficient logistics. Their quick product updates and 24/7 customer support set them apart from other platforms, enhancing my business significantly.</p>
              <el-button @click="()=>$emit('playVideo','https://img.kakaclo.com/web-img/home/video/video/2.mp4')">{{ $t('Home.Home.PlayVideo') }}</el-button>
            </div>
            <div class="store-box">
              <div class="store-header f">
                <div class="avator"><oss-img :width="48" :height="48" src="https://img.kakaclo.com/web-img/home/avator%20(1).png" alt="img" /></div>
                <div>
                  <h6>Thomas</h6>
                  <p>Brand Owner</p>
                </div>
              </div>
              <div class="semi"><oss-img :width="35" :height="24" src="https://img.kakaclo.com/web-img/home/home2.0/semi.png" alt="img" /></div>
              <p>I found KakaClo through a colleague's recommendation. Their extensive range of products and efficient shipping from China have been game-changers for my business, allowing me to offer a wider variety of styles and faster deliveries than ever before. KakaClo’s after-sales service and inventory updates keep them ahead of the competition, contributing greatly to my store's growth.</p>
              <el-button @click="()=>$emit('playVideo','https://img.kakaclo.com/web-img/home/video/video/1.mp4')">{{ $t('Home.Home.PlayVideo') }}</el-button>
            </div>
            <div class="store-box">
              <div class="store-header f">
                <div class="avator"><oss-img :width="48" :height="48" src="https://img.kakaclo.com/web-img/home/avator%20(6).png" alt="img" /></div>
                <div>
                  <h6>James</h6>
                  <p>Brand Owner</p>
                </div>
              </div>
              <div class="semi"><oss-img :width="35" :height="24" src="https://img.kakaclo.com/web-img/home/home2.0/semi.png" alt="img" /></div>
              <p>I discovered KakaClo when looking for an eco-friendly dropshipping partner. The choice was clear with their vast selection of styles and commitment to quality. Their fast shipping and responsive customer support have boosted my brand's reputation and sales.</p>
              <el-button @click="()=>$emit('playVideo','https://img.kakaclo.com/web-img/home/video/video/4.mp4')">{{ $t('Home.Home.PlayVideo') }}</el-button>
            </div>
          </div>
        </div>
        <div class="bar-box f f-c-c">
          <div class="pointer bar" @click="moveRight" v-show="toRight || toRight&&toLeft"> <oss-img :width="60" :height="60" src="https://img.kakaclo.com/web-img/home/Slice%202523%402x%20(1).png" alt="img" /></div>
          <div class="bar" style="cursor: not-allowed;" v-show="toLeft"> <oss-img :width="60" :height="60" src="https://img.kakaclo.com/web-img/home/Slice%202523%402x%20(2).png" alt="img" /></div>
          <div class="bar" style="cursor: not-allowed;" v-show="!toLeft&&!toRight"> <oss-img :width="60" :height="60" src="https://img.kakaclo.com/web-img/home/Slice%202523%402x(2).png" alt="img" /></div>
          <div class="pointer bar" @click="moveLeft" v-show="!toLeft"> <oss-img :width="60" :height="60" src="https://img.kakaclo.com/web-img/home/Slice%202523%402x(1).png" alt="img" /></div>
        </div>
      </div>

      <!-- FAQ区域 -->
      <div class="faq">
        <div class="box">
          <h2 class="title1">{{ $t('Home.Home.FrequentlyAskedQuestions') }}</h2>
          <el-collapse v-model="activeNames" @change="handleCollapseChange">
            <el-collapse-item :title="$t('Home.Home.HowLongDoesTheShippingTake1')" name="1" class="questions">
              <div class="answer">{{ $t('Home.Home.HowLongDoesTheShippingTake2') }}</div>
            </el-collapse-item>
            <el-collapse-item :title="$t('Home.Home.WhatIsFashionTrend1')" name="2" class="questions">
              <div class="answer">{{ $t('Home.Home.WhatIsFashionTrend2') }}</div>
            </el-collapse-item>
            <el-collapse-item :title="$t('Home.Home.Minimum1')" name="3" class="questions">
              <div class="answer">{{ $t('Home.Home.Minimum2') }}</div>
            </el-collapse-item>
            <el-collapse-item :title="$t('Home.Home.SyncProducts1')" name="4" class="questions">
              <div class="answer">{{ $t('Home.Home.SyncProducts2') }}</div>
            </el-collapse-item>
            <el-collapse-item :title="$t('Home.Home.SellOrFrom1')" name="5" class="questions">
              <div class="answer">
                {{ $t('Home.Home.SellOrFrom2') }}<br />
                {{ $t('Home.Home.SellOrFrom3') }}
              </div>
            </el-collapse-item>
            <el-collapse-item :title="$t('Home.Home.CustomizationService1')" name="6" class="questions">
              <div class="answer">
                {{ $t('Home.Home.CustomizationService2') }}<br />
                {{ $t('Home.Home.CustomizationService3') }}
              </div>
            </el-collapse-item>
          </el-collapse>
        </div>
      </div>

      <!-- 引导登录注册区域 -->
      <!-- <div class="guide" :style="{ height: userId ? '270px' : '340px' }">
        <h2 style="height: 30px; padding-top: 10px">{{ $t('Home.Mobile.StartSellingForFree') }}</h2>
        <div class="subheading">{{ $t('Home.Mobile.GrowYourFashionBusinessWithKakaClo') }}</div>
        <template v-if="userId">
          <el-button type="primary" style="margin-top: 15px" @click="jump('/mall')">{{ $t('Home.Mobile.StartSelling') }}</el-button>
        </template>
        <template v-else>
          <el-input v-model="email2" :placeholder="$t('Home.Mobile.YourEmail')" />
          <el-button type="primary" @click="sendEmail2">{{ $t('Home.Mobile.SignUpForFree') }}</el-button>
        </template>
      </div> -->
      <promotion-module-1></promotion-module-1>
    </div>
  </div>
</template>

<script>
import Swiper from 'swiper'
import 'swiper/dist/css/swiper.min.css'
import Collapse from 'vant/lib/collapse'
import 'vant/lib/collapse/style'
import CollapseItem from 'vant/lib/collapse-item'
import 'vant/lib/collapse-item/style'
import CategroyProductList from '../../components/CategroyProductList.vue'
import Banner from './Banner.vue'
import PromotionModule1 from './components/PromotionModule1.vue'

export default {
  name: 'MobileHome',
  components: {
    'van-collapse': Collapse,
    'van-collapse-item': CollapseItem,
    CategroyProductList,
    Banner,
    PromotionModule1
  },
  data() {
    return {
      activeNames: ['1'],
      email: '',
      email2: '',
      toLeft: false,
      toRight: false,
      offset: 0,
      childWidth: 267 // 子元素的宽度
    }
  },
  computed: {
    userId() {
      return this.$store.state.common.userId
    }
  },
  mounted() {
    this.initSwiper()
  },
  methods: {
    initSwiper() {
      this.$nextTick(() => {
        new Swiper('.swiper-container', {
          autoplay: 3000,
          loop: true,
          observer: true, // 修改swiper自己或子元素时，自动初始化swiper
          observeParents: true, // 修改swiper的父元素时，自动初始化swiper
          pagination: '.swiper-pagination'
        })
      })
    },

    jump(path, event_id) {
      if (['/product-list', '/mall'].includes(path)) {
        window.open(process.env.VUE_APP_MAIN_DOMAIN + path)
        return
      }
      this.$router.push(path)
    },

    sendEmail() {
      this.$router.push({
        name: '/register'
      })
    },

    sendEmail2() {
      this.$router.push({
        name: '/register',
        params: {
          email: this.email2
        }
      })
    },
    moveLeft() {
      let parentWidth = this.$refs.parent.offsetWidth
      let childWidth = this.$refs.child.offsetWidth
      let childRightOffset = parentWidth - (childWidth + this.offset)
      if (Math.abs(childRightOffset) > this.childWidth) {
        this.offset -= this.childWidth
        this.toRight = true
      } else if (childRightOffset < 0 && Math.abs(childRightOffset) <= this.childWidth) {
        this.offset -= Math.abs(childRightOffset)
        this.toLeft = true
      }
      this.$refs.child.style.transform = `translateX(${this.offset}px)`
    },
    moveRight() {
      let parentWidth = this.$refs.parent.offsetWidth
      let childWidth = this.$refs.child.offsetWidth
      if (this.offset < 0 && Math.abs(this.offset) > this.childWidth) {
        this.offset += this.childWidth
        this.toLeft = false
      } else if (this.offset < 0 && Math.abs(this.offset) <= this.childWidth) {
        this.offset = 0
        this.toLeft = false
        this.toRight = false
      }
      this.$refs.child.style.transform = `translateX(${this.offset}px)`
    },
    handleCollapseChange(newActiveNames) {
      this.activeNames = newActiveNames.slice(-1)
    }
  }
}
</script>

<style lang="scss" scoped>
@import './css/mobile.scss';
</style>
